(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- desktop dropdowns: click, hover (mouse only), Tab, Enter/Space, arrows, Esc ---------- */
    var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
    function allItems() { return Array.prototype.slice.call(document.querySelectorAll('[data-hf-nav-item]')); }
    function toggleOf(item) { return item.querySelector('[data-hf-nav-toggle]'); }
    function linksOf(item) { return Array.prototype.slice.call(item.querySelectorAll('.hf-nav__sublink')); }
    function setOpen(item, open) {
      clearTimeout(item._hfTimer);
      item.classList.toggle('is-open', open);
      var t = toggleOf(item); if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) item._hfHover = false;
    }
    function openItem(item, byHover) {
      allItems().forEach(function (it) { if (it !== item && it.classList.contains('is-open')) setOpen(it, false); });
      setOpen(item, true);
      item._hfHover = !!byHover;
    }

    function initNav(nav) {
      if (!nav || nav.hasAttribute('data-hf-nav-ready')) return;
      nav.setAttribute('data-hf-nav-ready', '');
      nav.classList.add('is-ready');
      Array.prototype.forEach.call(nav.querySelectorAll('[data-hf-nav-item]'), function (item) {
        var toggle = toggleOf(item);
        toggle.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          /* opened by hovering (or the mouseenter a tap fires first): the click keeps it open */
          if (open && item._hfHover) { item._hfHover = false; return; }
          if (open) setOpen(item, false); else openItem(item, false);
        });
        toggle.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          openItem(item, false);
          var links = linksOf(item);
          var l = e.key === 'ArrowDown' ? links[0] : links[links.length - 1];
          if (l) l.focus();
        });
        item.addEventListener('keydown', function (e) {
          var links = linksOf(item), i = links.indexOf(document.activeElement);
          if (i < 0) return;
          if (e.key === 'ArrowDown') { e.preventDefault(); links[(i + 1) % links.length].focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); if (i === 0) toggle.focus(); else links[i - 1].focus(); }
          else if (e.key === 'Home') { e.preventDefault(); links[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); links[links.length - 1].focus(); }
        });
        item.addEventListener('focusout', function (e) {
          if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(item, false);
        });
        item.addEventListener('mouseenter', function () {
          if (!hoverMq.matches) return;
          clearTimeout(item._hfTimer);
          if (!item.classList.contains('is-open')) openItem(item, true);
        });
        item.addEventListener('mouseleave', function () {
          if (!hoverMq.matches || !item._hfHover) return;
          item._hfTimer = setTimeout(function () { setOpen(item, false); }, 200);
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      allItems().forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var hadFocus = item.contains(document.activeElement);
        setOpen(item, false);
        if (hadFocus) toggleOf(item).focus();
      });
    });
    document.addEventListener('click', function (e) {
      allItems().forEach(function (item) { if (item.classList.contains('is-open') && !item.contains(e.target)) setOpen(item, false); });
    });

    /* ---------- mobile drawer: burger state, focus stays inside, focus back to the burger, no page scroll ---------- */
    var opener = null;
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-hf-drawer-open]');
      if (o) opener = o;
    }, true);

    function focusables(root) {
      return Array.prototype.filter.call(
        root.querySelectorAll('a[href], button:not([disabled]), summary, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.tabIndex >= 0 && el.getClientRects().length > 0; }
      );
    }

    function initDrawer(drawer) {
      if (!drawer || drawer.hasAttribute('data-hf-drawer-ready')) return;
      drawer.setAttribute('data-hf-drawer-ready', '');
      var panel = drawer.querySelector('.hf-drawer__panel');
      var closeBtn = drawer.querySelector('.hf-drawer__head [data-hf-drawer-close]');
      new MutationObserver(function () {
        var open = !drawer.hidden;
        Array.prototype.forEach.call(document.querySelectorAll('[data-hf-drawer-open]'), function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        /* hf-theme.js focuses the first close button, which is the dark background: move focus to the visible one */
        if (open && closeBtn) closeBtn.focus({ preventScroll: true });
        if (!open && opener && (drawer.contains(document.activeElement) || document.activeElement === document.body)) opener.focus({ preventScroll: true });
      }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });

      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || drawer.hidden) return;
        var f = focusables(panel); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* a swipe on the dark background must not scroll the page */
      var scrim = drawer.querySelector('.hf-drawer__scrim');
      if (scrim) scrim.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
      /* turning a tablet to landscape (desktop menu) closes the drawer */
      var wide = window.matchMedia('(min-width: 1024px)');
      var onWide = function () { if (wide.matches && !drawer.hidden) { var c = drawer.querySelector('.hf-drawer__head [data-hf-drawer-close]'); if (c) c.click(); } };
      if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
    }

    function init() {
      initNav(document.querySelector('[data-hf-nav]'));
      initDrawer(document.querySelector('[data-hf-drawer]'));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-dinner-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMore(box) {
      if (box.dataset.hfInit) return;
      box.dataset.hfInit = '1';
      var body = box.querySelector('[data-hf-dinner-more-body]');
      var btn = box.querySelector('[data-hf-dinner-more-btn]');
      if (!body || !btn) return;
      box.classList.add('is-clamped');
      if (body.scrollHeight <= body.clientHeight + 8) { box.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
        if (!open && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start' });
      });
    }
    function initBar(bar) {
      if (bar.dataset.hfInit) return;
      bar.dataset.hfInit = '1';
      var actions = document.getElementById(bar.getAttribute('data-for'));
      if (!actions || !('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
      new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting); }).observe(actions);
    }
    function init(root) {
      root.querySelectorAll('[data-hf-dinner-more]').forEach(initMore);
      root.querySelectorAll('[data-hf-dinner-bar]').forEach(initBar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hf-toggle]');
    if (t) { var el = document.querySelector(t.getAttribute('data-hf-toggle')); if (el) el.hidden = !el.hidden; }
    var d = e.target.closest('[data-hf-address-delete]');
    if (d && window.Shopify && Shopify.postLink && confirm(d.getAttribute('data-confirm'))) {
      Shopify.postLink('/account/addresses/' + d.getAttribute('data-hf-address-delete'), { parameters: { _method: 'delete' } });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe"]) return;
  try {
    
  (function () {
    function init() {
      var bar = document.querySelector('[data-hf-rcp-bar]');
      if (!bar) return;
      var targets = document.querySelectorAll('[data-hf-rcp-buy]');
      if (!targets.length || !('IntersectionObserver' in window)) return;
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        var any = false;
        seen.forEach(function (v) { if (v) any = true; });
        bar.classList.toggle('is-away', any);
      }, { threshold: 0.2 });
      targets.forEach(function (t) { io.observe(t); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
